var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"heads"},[_c('el-image',{attrs:{"src":require('@/assets/images/Assessment1.jpg')}}),_c('el-image',{attrs:{"src":require('@/assets/images/Assessment2.jpg')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }